import { useQuery } from '@tanstack/react-query';

import { getStripePortalQuery } from '@/components/OurPlans/components/Plans/components/PlanButton/query';
import useUser from '../useUser';

export const useStripePortal = (planId?: string) => {
  const { data: user } = useUser();

  const { data, status } = useQuery({
    queryKey: ['STRIPE_PORTAL', planId],
    queryFn: getStripePortalQuery,
    staleTime: 600000,
    enabled: user.loggedIn,
  });
  return { data, status };
};
